export default class CodeHighlighter {
  constructor(elem, options) {
    this.elem = elem;
    this.options = options;
    this.tagRegex = /<([^\s>]+)/g;
    this.attributeRegex = /([^\s=]+)="([^"]*)"/g;
    this.classNames = {
      symbol: this._selectString(this.options?.classNames?.symbol, "code__symbol"),
      tag: this._selectString(this.options?.classNames?.tag, "code__property"),
      attr: this._selectString(this.options?.classNames?.attr, "code__property"),
      value: this._selectString(this.options?.classNames?.value, "code__value")
    };
    this.tags = {
      symbol: this._selectString(this.options?.tags?.symbol, "code"),
      tag: this._selectString(this.options?.tags?.tag, "code"),
      attr: this._selectString(this.options?.tags?.attr, "code"),
      value: this._selectString(this.options?.tags?.value, "code")
    };
    this.elem && this.highlight();
  }

  _selectString(a, b){
    if(typeof a == "string"){
      return a;
    } else if(typeof b == "string"){
      return b;
    } else {
      return "";
    }
  }

  wrap(value, cls) {
    let wrapper = "<code class='{{className}}'>{{value}}</code>";
    if(!this.classNames[cls]){
      wrapper = "<code>{{value}}</code>";
    }
    if(this.tags[cls]){
      wrapper = wrapper.replace(/code/g, this.tags[cls]);
    } else {
      wrapper = "{{value}}";
    }
    return wrapper
      .replace("{{className}}", this.classNames[cls])
      .replace("{{value}}", value);
  }

  parseHTML(html) {
    const matches = html.matchAll(this.tagRegex);
    const result = [];

    for (let match of matches) {
      const tagStartIndex = match.index;
      const tagEndIndex = html.indexOf('>', tagStartIndex);
      const tagContent = html.slice(tagStartIndex, tagEndIndex + 1);
      const attributes = {};
      const attributeMatches = Array.from(tagContent.matchAll(this.attributeRegex));
      for (let amatch of attributeMatches) {
        attributes[amatch[1]] = amatch[2];
      }
      result.push({
        tagName: match[1],
        attributes: attributes
      });
    }

    return result;
  }

  highlight(code) {
    const content = code || this.elem.innerText;
    const parsed = this.parseHTML(content);
    let resultHTML = "";

    for (let elem of parsed) {
      resultHTML += this.wrap("<", "symbol");
      resultHTML += this.wrap(elem.tagName, "tag");
      for (let attr in elem.attributes) {
        resultHTML += " ";
        resultHTML += this.wrap(attr, "attr");
        resultHTML += this.wrap("=", "symbol");
        resultHTML += this.wrap("\"", "symbol");
        resultHTML += this.wrap(elem.attributes[attr], "value");
        resultHTML += this.wrap("\"", "symbol");
      }
      resultHTML += this.wrap(">", "symbol");
      resultHTML += "<br>";
    }
    if(code){
      return resultHTML;
    }
    this.elem.innerHTML = resultHTML;
  }
}